import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fileUrl } from "../lib/api";
import { Download, ExternalLink } from "lucide-react";

const statusColor = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  archived: "bg-neutral-100 text-neutral-600 border-neutral-300",
  sold_out: "bg-purple-50 text-purple-700 border-purple-200",
  sold_exclusive: "bg-blue-50 text-blue-700 border-blue-200",
};

export default function AdminLibrary() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");

  const load = () => {
    const params = {};
    if (q) params.q = q;
    if (status) params.status = status;
    api.get("/admin/library", { params }).then((r) => setItems(r.data)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [status]);

  const filters = ["", "approved", "pending", "rejected", "archived", "sold_out", "sold_exclusive"];

  return (
    <div data-testid="admin-library">
      <h1 className="font-serif text-4xl font-light tracking-tight mb-2">Biblioteca de archivos</h1>
      <p className="text-sm text-neutral-500 mb-6">Repositorio completo de obras originales para impresión. Click en una imagen para descargar el archivo en alta resolución.</p>

      <div className="flex flex-wrap gap-3 mb-6">
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex gap-2">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por título..." className="border border-neutral-300 px-4 py-2 text-sm bg-white w-72" data-testid="library-search" />
          <button type="submit" className="overline text-xs px-4 py-2 border border-black hover:bg-neutral-50">Buscar</button>
        </form>
        <div className="flex gap-1 flex-wrap">
          {filters.map((s) => (
            <button key={s || "all"} onClick={() => setStatus(s)} className={`overline text-xs px-3 py-2 border ${status === s ? "bg-black text-white border-black" : "border-neutral-300 hover:bg-neutral-50"}`} data-testid={`lib-filter-${s || "all"}`}>
              {s || "Todas"}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-testid="library-grid">
        {items.map((a) => (
          <div key={a.id} className="bg-white border border-neutral-200 group" data-testid={`lib-${a.id}`}>
            <div className="aspect-square bg-neutral-100 overflow-hidden relative">
              <img src={fileUrl(a.image_path, "md")} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
              <a href={fileUrl(a.image_path, "orig")} download={`${a.title}-original`} target="_blank" rel="noreferrer" className="absolute inset-0 bg-black/60 text-white opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-2" data-testid={`lib-download-${a.id}`}>
                <Download size={24} strokeWidth={1.2} />
                <span className="overline text-[10px]">Descargar original</span>
              </a>
            </div>
            <div className="p-3">
              <div className="flex items-center justify-between mb-2">
                <span className={`overline text-[9px] px-2 py-0.5 border ${statusColor[a.status] || ""}`}>{a.status}</span>
                <Link to={`/artwork/${a.id}`} target="_blank" className="text-neutral-400 hover:text-black"><ExternalLink size={12} /></Link>
              </div>
              <div className="font-serif text-sm leading-tight line-clamp-2">{a.title}</div>
              <div className="text-[10px] text-neutral-500 mt-1">{a.artist_name}</div>
              {a.max_impressions && (
                <div className="text-[10px] text-neutral-500 mt-1">Edición {a.prints_sold || 0}/{a.max_impressions}</div>
              )}
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-5 py-12 text-center overline text-neutral-400">Sin obras</div>}
      </div>
    </div>
  );
}
